<template>
  <div class="home">
    <firstSection/>
    <secondSection/>
    <thirdSection/>
  </div>
</template>

<script>
// @ is an alias to /src
import firstSection from "@/components/pages/home/FirstSection.vue";
import secondSection from "@/components/pages/home/SecondSection.vue";
import thirdSection from "@/components/pages/home/ThirdSection.vue";
export default {
  name: "home",
  components: {
    firstSection,
    secondSection,
    thirdSection
  }
};
</script>
